import script from "./GoogleAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleAccess.vue?vue&type=script&setup=true&lang=js"

import "./GoogleAccess.vue?vue&type=style&index=0&id=68840f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68840f0e"]])

export default __exports__